// import { useQuery } from '@tanstack/react-query';
// import { customerServices } from '../services/customer.service';

// export const useCustomers = (filters) => {
//   return useQuery({
//     queryKey: ['customers', filters],
//     queryFn: () => customerServices.getCustomers(filters),
//     staleTime: 1000 * 60 * 5, // 5 minutes
//   });
// };


import { useQuery } from '@tanstack/react-query';
import { customerServices } from '../services/customer.service';

/**
 * Reusable API error parser
 */
const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong',

    status: error?.response?.status || 500,

    errors: error?.response?.data?.errors || [],
  };
};

/**
 * Get all customers
 */
export const useCustomers = (filters) => {
  return useQuery({
    queryKey: ['customers', filters],

    queryFn: async () => {
      try {
        return await customerServices.getCustomers(filters);
      } catch (error) {
        throw parseApiError(error);
      }
    },

    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes

    placeholderData: (previousData) => previousData,

    retry: 1,
  });
};